import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './product-detail.scss';

type Props = ComponentPropsWithoutRef<'span'>;
export const ProductDetailAddonsItemName = ({ className, ...props }: Props) => {
    return <span className={cn('product-detail__addons-item-name', className)} {...props} />;
};
